export const upsellingHc = {
  servicios: {
    accommodation: "Acomodação",
    all: "Todos",
    state: "Status",
    search: "Buscar",
    searchPlaceholder: "Hóspede ou código da reserva…",
    from: "De",
    to: "Até",
    today: "Hoje",
    noDate: "Sem data",
    clear: "Limpar",
    thService: "Serviço",
    thGuest: "Hóspede",
    thBooking: "Reserva",
    thRequested: "Solicitado",
    statusConsult: "Sob consulta",
    statusRejected: "Recusado",
    statusPaid: "Pago",
    statusPartial: "Pagamento parcial",
    statusApproved: "Aprovado",
    statusPending: "Pendente",
    serviceFallback: "Serviço",
    openBookingTitle: "Abrir a reserva",
    approve: "Aprovar",
    reject: "Recusar",
    viewBooking: "Ver reserva",
    noRecords: "Sem registros",
    noRecordsFiltered: "Nenhum registro encontrado com os filtros aplicados.",
    noRequestsYet: "Assim que um hóspede solicitar um serviço, ele aparecerá aqui.",
    chipBreakfast: "Café da manhã",
    chipTour: "Passeio",
    chipTransport: "Transporte",
    chipMore: "E o que você oferecer",
    approveTitle: "Aprovar solicitação",
    amountLabel: "Valor a cobrar",
    amountFree: "0 = sem cobrança",
    amountHint: "Com um gateway de pagamento conectado, o hóspede recebe um <strong>link de pagamento</strong> (WhatsApp + e-mail). Caso contrário, é informado de que <strong>pagará na chegada</strong>.",
    cancel: "Cancelar",
    processing: "Processando…",
    approveAndNotify: "Aprovar e avisar",
    amountInvalid: "Informe um valor válido (0 = sem cobrança).",
    approvedPaymentLink: "Aprovada. O link de pagamento foi enviado ao hóspede (WhatsApp + e-mail).",
    approvedOnArrival: "Aprovada. O hóspede pagará na chegada (sem gateway conectado).",
    approvedNotified: "Aprovada. O hóspede foi avisado.",
    approveFailed: "Não foi possível aprovar a solicitação.",
    rejectTitle: "Recusar solicitação",
    rejectMessage: "Ao recusá-la, o hóspede NÃO será cobrado por este serviço e será avisado. Recusar a solicitação?",
    rejected: "Solicitação recusada. O hóspede foi avisado.",
    rejectFailed: "Não foi possível recusar a solicitação.",
  },
  form: {
    basicTitle: "Informações básicas",
    basicDesc: "O nome e a descrição que o hóspede verá.",
    autoTranslate: "Escreva no <strong>seu idioma</strong>. Ao salvar, é traduzido <strong>automaticamente</strong> para todos os idiomas (espanhol, inglês, português, francês, alemão, italiano, chinês e árabe); o hóspede verá o seu.",
    selectPlaceholder: "Selecionar…",
    catNightlife: "Vida noturna",
    subtitleLabel: "Subtítulo",
    optional: "opcional",
    subtitlePlaceholder: "Um gancho curto, ex.: “Viva a experiência”",
    price: "Preço",
    priceDesc: "Como este serviço é cobrado do hóspede.",
    segWithPrice: "Com preço",
    segWithPriceDesc: "Cobrado automaticamente",
    segOnRequest: "Sob consulta",
    segOnRequestDesc: "O hóspede pergunta, você cota",
    currencyLabel: "Moeda",
    currencyHint: "a do anúncio",
    chargeBy: "Cobrar por",
    unitPlaceholder: "Escolha o modo…",
    unitPerUnit: "Por unidade (preço fixo)",
    unitPerPerson: "Por pessoa (× hóspedes)",
    unitPerNight: "Por noite (× noites)",
    unitPerGroup: "Por grupo / estadia",
    unitPerHour: "Por hora",
    unitHintPerson: "Será multiplicado pelo número de hóspedes da reserva.",
    unitHintNight: "Será multiplicado pelo número de noites da reserva.",
    unitHintUnit: "Preço fixo para cada unidade que o hóspede comprar.",
    unitHintGroup: "Preço único pela reserva, independentemente de pessoas ou noites.",
    unitHintHour: "Preço por hora contratada.",
    unitLabelPerson: "/ por pessoa",
    unitLabelNight: "/ por noite",
    unitLabelGroup: "/ por estadia",
    unitLabelHour: "/ por hora",
    stockControl: "Controlar estoque",
    inventory: "inventário",
    stockDesc: "Para o que se esgota (ex.: uma cama ou berço extra): limite as unidades. São descontadas sozinhas a cada reserva e em tempo real.",
    unitsAvailable: "Unidades disponíveis",
    removeUnitAria: "Remover uma unidade",
    addUnitAria: "Adicionar uma unidade",
    stockNoteSoldOut: "Com <strong>0</strong> unidades, o serviço aparece como <strong>Esgotado</strong> e não pode ser adicionado.",
    stockNoteAuto: "Ao chegar a 0, será exibido <strong>Esgotado</strong> automaticamente.",
    stockConsumePerson: "Cada reserva desconta 1 unidade por hóspede.",
    stockConsumeNight: "Cada reserva desconta 1 unidade por noite.",
    stockModeTitle: "Como o estoque funciona",
    stockModeAvail: "Por disponibilidade",
    stockModeAvailDesc: "É ocupado apenas durante a estadia e liberado no checkout (berço, cama extra).",
    stockModeProduct: "Por produto",
    stockModeProductDesc: "É descontado a cada reserva e não volta. Você repõe manualmente.",
    stockUnlimited: "Estoque ilimitado — sem limite de unidades.",
    photosTitle: "Fotos",
    photoMain: "Principal",
    makeMainTitle: "Tornar principal",
    removeTitle: "Remover",
    addPhoto: "Adicionar foto",
    addPhotos: "Adicionar fotos",
    reorderHint: "Arraste para reordenar · a primeira é a que aparece no cartão.",
    whereTitle: "Onde é oferecido?",
    whereDesc: "Anúncios onde estará disponível. Sem seleção = todos.",
    selected: "{count} selecionados",
    all: "Todos",
    none: "Nenhum",
    searchListingPlaceholder: "Buscar anúncio…",
    noResults: "Sem resultados",
    diffCurrencyTitle: "Este anúncio usa {currency}. Um serviço fica em uma única moeda.",
    unit: "unidade",
    units: "unidades",
    loadingListings: "Carregando anúncios…",
    previewLabel: "Prévia · é assim que o hóspede verá",
    previewPhoto: "Sua foto principal",
    previewTitleFallback: "Nome do serviço",
    previewDescFallback: "Aqui aparecerá a descrição que você escrever, para que o hóspede saiba o que está incluído.",
    free: "Grátis",
    soldOut: "Esgotado",
    add: "Adicionar",
    remaining: "Resta {count} unidade | Restam {count} unidades",
    scopeManaged: "Oferecido em <strong>todos os seus anúncios</strong>. Escolha quais na lista Serviços e experiências.",
    scopeAll: "Disponível em <strong>todas as suas acomodações</strong>",
    scopeSome: "Disponível em <strong>{count}</strong> anúncio | Disponível em <strong>{count}</strong> anúncios",
    errNameRequired: "O nome é obrigatório",
    errCategoryRequired: "A categoria é obrigatória",
    errDescRequired: "A descrição é obrigatória",
    errPriceRequired: "Informe um preço (coloque 0 se for grátis).",
    errPriceNegative: "O preço não pode ser negativo.",
    errUnitRequired: "Escolha como é cobrado (Cobrar por)",
    errStockRequired: "Informe quantas unidades há em estoque (coloque 0 se estiver esgotado).",
    errProcessing: "Erro ao processar a solicitação.",
  },
  createServicio: {
    subtitle: "Preencha as informações e veja a prévia em tempo real.",
    photosDesc: "Adicione quantas quiser · a 1ª é a principal · JPG, PNG ou WebP.",
    imageRequired: "Envie ao menos uma imagem.",
  },
  updateServicio: {
    title: "Editar experiência ou serviço",
    subtitle: "Atualize as informações e veja a prévia em tempo real.",
    loadingAria: "Carregando serviço",
    photosDesc: "Adicione ou remova quantas quiser · a 1ª é a principal · JPG, PNG ou WebP.",
    save: "Salvar alterações",
    imageRequired: "Deve permanecer ao menos uma imagem.",
    loadFailed: "Não foi possível carregar o serviço.",
  },
  configUpselling: {
    title: "Configuração de Vendas Cruzadas",
    phoneIntro: "Informe o número de telefone que deseja usar para receber as notificações de solicitações de serviço pelo WhatsApp",
    saveWhatsapp: "Salvar WhatsApp",
    editWhatsapp: "Editar WhatsApp",
    mustEnterWhatsapp: "Você precisa informar o WhatsApp",
    swalTitle: "WhatsApp de vendas cruzadas",
    swalText: "Você receberá todas as notificações dos serviços solicitados pelos clientes",
    cancel: "Cancelar",
    addedSuccess: "WhatsApp adicionado com sucesso",
  },
};
